import "./topupmodal.css";
import Modal from "react-bootstrap/Modal";
import { AiOutlinePlus } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { togglePayment } from "../../redux/slices/accountSlice";

const TopUpModal = ({ setTopUpModalShow, show }) => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  const handleTopUp = () => {
    setTopUpModalShow(false);
    dispatch(togglePayment({ payment: true }));
  };

  return (
    <Modal
      show={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={
        isDarkMode
          ? "modal-body-topup modal-content-dark"
          : "modal-body-topup modal-content-light"
      }
    >
      <h5
        className={
          isDarkMode ? "LowBalanceMsg low-balance-dark" : "LowBalanceMsg "
        }
        style={{ color: "#6c757d" }}
      >
        Oops, your balance is too low
      </h5>
      <Modal.Body className="modalBodyTopup">
        <button
          onClick={handleTopUp}
          className="w-30 filled-medium-deep-yellow-btn-dark"
        >
          <span>
            <AiOutlinePlus />
            Top Up
          </span>
        </button>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => setTopUpModalShow(false)}
          className="w-30 deep-primary-monochrome-btn-dark"
        >
          <span>Close</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default TopUpModal;
